/** @jsxImportSource @emotion/react */
"use client";
import { matchSelectableGuide } from "@packages/media";
import type { SelectableGuide } from "@packages/sdk";
import { useHover } from "react-aria";

import { ModalDropdownMenuItem } from "../../../../../components/_base/modals/ModalDropdownMenuItem/ModalDropdownMenuItem.emotion";
import { GuideInfo } from "../../data/GuideInfo/GuideInfo.emotion";

export type SelectGuideListProps = {
  selectedGuides: number[] | undefined;
  onGuideSelection: (guides: number[]) => void;
  options: SelectableGuide[];
};

const InternalSelectableGuideModalDropdownMenuItem = ({
  guide,
  onSelect,
  selected,
}: {
  guide: SelectableGuide;
  onSelect: () => void;
  selected: boolean;
}) => {
  const { hoverProps, isHovered } = useHover({});

  return (
    <div {...hoverProps}>
      <ModalDropdownMenuItem
        {...hoverProps}
        onSelect={onSelect}
        selected={selected}
      >
        <GuideInfo guide={guide} isHovered={isHovered} />
      </ModalDropdownMenuItem>
    </div>
  );
};

export const SelectGuideList = ({
  options,
  selectedGuides,
  onGuideSelection,
}: SelectGuideListProps) => (
  <>
    {(options ?? []).map((option) => (
      <InternalSelectableGuideModalDropdownMenuItem
        key={`sessionDetails_selectGuide_guide_${option.name}`}
        guide={option}
        onSelect={() => onGuideSelection(option.guide_ids)}
        selected={matchSelectableGuide(option.guide_ids, selectedGuides)}
      />
    ))}
  </>
);
